module.exports = __webpack_public_path__ + "static/media/bookr_news.da049624.png";